import { useEffect, useMemo, useState } from "react";
import { Column, DataTableClient, DateBody, } from "components/common/DataTable";
import { Dropdown, GridForm, Input, } from "components/common/ListForm";
import { useHandleParamUrl } from "hooks/useHandleParamUrl";
import { classNames } from "primereact/utils";
import { MyCalendar } from "components/common/MyCalendar";
import { useListSupplierDetailWithState } from "modules/partner/service";
import { Checkbox, Dialog } from "components/uiCore";
import { useListEmployeeWithState } from "modules/employee/service";
import { Helper } from "utils/helper";
import { useListDebitCongNoChiTietNCC, useListDebitDuNoDKNCC } from "../service";
import { listToast, TypeDebitDKKH } from "utils";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import UpdatePhieuChiNCC from "modules/receipt/screen/update_phieuchi_ncc";
import { Splitter } from "primereact/splitter";
import { exportDebitNCC } from "../api";
import { showToast } from "redux/features/toast";
import { useDispatch } from "react-redux";

// ✅ Component Header lọc dữ liệu
const Header = ({ _setParamsPaginator, _paramsPaginator ,selected ,refresh,_setSelectedRows}: any) => {
  const [filter, setFilter] = useState({
    name: "",
    supplierDetailId: "",
    fromDate: Helper.lastWeekString(),
    toDate: Helper.toDayString(),
  });
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
   const [dunoDK, setdunoDK] = useState<number>(0);
  const { data: supplierDetails } = useListSupplierDetailWithState({ status: 2});
  const { data:dunoDKNCC, loading: loadingDNDKNCC } = useListDebitDuNoDKNCC({ params: {..._paramsPaginator}});
  // --- chuyển sang options bằng useMemo ---
  const supplierOptions = useMemo(() => {
    if (!Array.isArray(supplierDetails)) return [];
    return supplierDetails.map((x: any) => ({
      label: x?.partners?.abbreviation ?? "(không tên)",
      value: x.id,
    }));
  }, [supplierDetails]);
  const openDialogAdd = () => {
    console.log(selected);
    if (filter.supplierDetailId === "" || filter.supplierDetailId === undefined) {
      dispatch(showToast({ ...listToast[2], detail: "Hãy chọn nhà cung cấp" }));
      return;
    }
    setVisible(true);
  };
  const handleModalClose = () => {
      setVisible(false);
      _setSelectedRows([])
      refresh?.(); 
  };
  useEffect(() => {
    // Mỗi khi filter thay đổi => cập nhật params
    _setParamsPaginator((prev: any) => ({
      ...prev,
      keyword: filter.name,
      supplierDetailId: filter.supplierDetailId,
      fromDate: filter.fromDate,
      toDate: filter.toDate,
    }));
     console.log(dunoDKNCC);
    setdunoDK(0)
    if(dunoDKNCC && dunoDKNCC[0]){
        setdunoDK(dunoDKNCC[0].total_debit - dunoDKNCC[0].total_receipt)
    }
    _setSelectedRows([]); // mỗi khi filter thay đổi thì reset selected rows về rỗng
  }, [dunoDKNCC,filter]);
  async function ExportExcelCongNoNCC(){
    const respo = await exportDebitNCC(Helper.convertObjectToQueryString(_paramsPaginator));
    const url = window.URL.createObjectURL(new Blob([respo.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'cong_no_chi_tiet_ncc.xlsx'); // or any other extension
    document.body.appendChild(link);
    link.click();
    link?.parentNode?.removeChild(link);  
  }
  const items = [
        {
            label: 'Công nợ chi tiết',
            icon: "pi pi-file-export",
            command: () => ExportExcelCongNoNCC()
        }
  ];
  return (
    <>
      <GridForm
        paramsPaginator={_paramsPaginator}
        setParamsPaginator={_setParamsPaginator}
        filter={filter}
        setFilter={setFilter}
        className="lg:col-9"
        openDialogAdd={()=>openDialogAdd()}
        openDialogAddName="Lập phiếu chi"
        MenuItems={items}
      >
        <div className="col-2">Ngày công nợ</div>
        <div className="col-2">
          <MyCalendar
            dateFormat="dd/mm/yy"
            value={filter.fromDate}
            onChange={(e: any) => setFilter({ ...filter, fromDate: e })}
            className={classNames("w-full", "p-inputtext", "input-sm")}
          />
        </div>
        <div className="col-2">
          <MyCalendar
            dateFormat="dd/mm/yy"
            value={filter.toDate}
            onChange={(e: any) => setFilter({ ...filter, toDate: e })}
            className={classNames("w-full", "p-inputtext", "input-sm")}
          />
        </div>
        <div className="col-4">
          <Dropdown
            filter
            showClear
            value={filter.supplierDetailId}
            options={supplierOptions}
            onChange={(e: any) =>
              setFilter({ ...filter, supplierDetailId: e.target.value })
            }
            label="Nhà cung cấp"
            className={classNames("dropdown-input-sm", "p-dropdown-sm")}
          />
        </div>
         <div className="col-2">
             <div><b>Dư nợ đầu kỳ: {dunoDK ? Helper.formatCurrency(dunoDK.toString()):0}</b></div>
         </div>
      </GridForm>
      <Dialog
            position="top"
            dismissableMask
            visible={visible}
            onHide={() => setVisible(false)}
            style={{ width: "70vw", top:"30px" }}
        >
          <p className="m-0">
            {selected && <UpdatePhieuChiNCC debits={selected} supplierDetailId={filter.supplierDetailId} onClose={handleModalClose} ></UpdatePhieuChiNCC>}
          </p>
      </Dialog>
    </>
  );
};

export default function ListChiTietNCC() {
  const { handleParamUrl } = useHandleParamUrl();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [displayData, setDisplayData] = useState<any[]>([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(12);
  const { data: suppliers } = useListSupplierDetailWithState({status: 2});
  const { data: employees } = useListEmployeeWithState({});
  const [paramsPaginator, setParamsPaginator] = useState({
    pageNum: 1,
    pageSize: 20,
    first: 0,
    render: false,
    keyword: "",
  });
  const [filters, setFilters] = useState({
      fileNumber: "",
      supplierAbb:"",
      bill: "",
      declaration: "",
      dispatch_code: "",
      name: "",
      file_bill: "",
      cont: "",
      conlai_dv_view: "",
      conlai_ch_view: "",
  });
  const { data, loading, error, refresh } = useListDebitCongNoChiTietNCC({
    params: paramsPaginator,
    debounce: 500,
  });
    // --- Header template with filter ---
  const supplierAbbHeader = (
     <div className="py-1">
         <Input
            value={filters.supplierAbb}
            onChange={(e:any) => setFilters({ ...filters, supplierAbb: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    const fileNumberHeader = (
     <div className="py-1">
         <Input
            value={filters.fileNumber}
            onChange={(e:any) => setFilters({ ...filters, fileNumber: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    const billHeader = (
     <div className="py-1">
         <Input
            value={filters.bill}
            onChange={(e:any) => setFilters({ ...filters, bill: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    const contHeader = (
     <div className="py-1">
         <Input
            value={filters.cont}
            onChange={(e:any) => setFilters({ ...filters, cont: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    const declarationHeader = (
     <div className="py-1">
         <Input
            value={filters.declaration}
            onChange={(e:any) => setFilters({ ...filters, declaration: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    const dispatchCodeHeader = (
     <div className="py-1">
         <Input
            value={filters.dispatch_code}
            onChange={(e:any) => setFilters({ ...filters, dispatch_code: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    const nameHeader = (
     <div className="py-1">
         <Input
            value={filters.name}
            onChange={(e:any) => setFilters({ ...filters, name: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
  const fileBillHeader = (
     <div className="py-1">
         <Input
            value={filters.file_bill}
            onChange={(e:any) => setFilters({ ...filters, file_bill: e.target.value })}
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
      const phatSinhDichVuHeader = (
     <div className="py-1">
         <Input
            type="text"
            value={filters.conlai_dv_view}
            onChange={(e:any) => setFilters({ ...filters, conlai_dv_view: e.target.value })}
            label="><=giá trị"
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );   
   const phatSinhChiHoHeader = (
     <div className="py-1">
         <Input
            type="text"
            value={filters.conlai_ch_view}
            onChange={(e:any) => setFilters({ ...filters, conlai_ch_view: e.target.value })}
            label="><=giá trị"
            size="small"
            className={classNames("input-sm")}
          />
     </div>
  );
    // --- Filter dữ liệu dựa vào input ---
const applyFilters = (rows: any[]) => {
    return rows.filter((row) => {
        const f = filters;

        return (
            (f.supplierAbb ? row.supplierAbb?.toLowerCase().includes(f.supplierAbb.toLowerCase()) : true) &&
            (f.fileNumber ? row.fileNumber?.toLowerCase().includes(f.fileNumber.toLowerCase()) : true) &&
            (f.bill ? row.bill?.toLowerCase().includes(f.bill.toLowerCase()) : true) &&
            (f.cont ? row.cont?.toLowerCase().includes(f.cont.toLowerCase()) : true) &&
            (f.declaration ? row.declaration?.toLowerCase().includes(f.declaration.toLowerCase()) : true) &&
            (f.dispatch_code ? row.dispatch_code?.toLowerCase().includes(f.dispatch_code.toLowerCase()) : true) &&
            (f.name ? row.name?.toLowerCase().includes(f.name.toLowerCase()) : true) &&
            (f.file_bill ? row.file_bill?.toLowerCase().includes(f.file_bill.toLowerCase()) : true)&&
             (f.conlai_dv_view.trim() ? (() => {
              const input = f.conlai_dv_view.trim();
              const match = input.match(/^([><=!]+)\s*(\d+(?:\.\d+)?)$/);
              let operator = '>';
              let num = 0;
              if (match) {
                operator = match[1];
                num = parseFloat(match[2]);
              } else {
                num = parseFloat(input);
                if (isNaN(num)) return true;
              }
              switch (operator) {
                case '>': return row.conlai_dv_view > num;
                case '>=': return row.conlai_dv_view >= num;
                case '=': case '==': return row.conlai_dv_view === num;
                case '<=': return row.conlai_dv_view <= num;
                case '<': return row.conlai_dv_view < num;
                default: return row.conlai_dv_view > num;
              }
            })() : true)
            &&
            (f.conlai_ch_view.trim() ? (() => {
              const input = f.conlai_ch_view.trim();
              const match = input.match(/^([><=!]+)\s*(\d+(?:\.\d+)?)$/);
              let operator = '>';
              let num = 0;
              if (match) {
                operator = match[1];
                num = parseFloat(match[2]);
              }
              else {
                num = parseFloat(input);
                if (isNaN(num)) return true;
              }
              switch (operator) {
                case '>': return row.conlai_ch_view > num;
                case '>=': return row.conlai_ch_view >= num;
                case '=': case '==': return row.conlai_ch_view === num;
                case '<=': return row.conlai_ch_view <= num;
                case '<': return row.conlai_ch_view < num;
                default: return row.conlai_ch_view > num;
              }
            })() : true)
        );
    });
};
 const getSumColumn = (field: string) => {
        const filtered = (displayData??[]).filter((item: any) => {
            return Object.entries(filters).every(([key, f]: [string, any]) => {
                const value = f?.value?.toString().toLowerCase() ?? "";
                if (!value) return true;
                const cell = item[key]?.toString().toLowerCase() ?? "";
                return cell.includes(value);
            });
        });

        const sum = filtered.reduce((acc: any, item: any) => {
            const val = parseInt(item[field]?.toString().replace(/\D/g, ""), 10) || 0;
            return acc + val;
        }, 0);

        return Helper.formatCurrency(sum.toString());
    };
useEffect(() => {
    if (!data) return;

    handleParamUrl(paramsPaginator);
    console.log(suppliers);
    
    const mapped = (data?.data || []).map((row: any) => {
        const sup = suppliers.find((x: any) => x.id === row.supplier_detail_id);
        const _user = employees.find((x: any) => x.user_id === row.updated_by);
        const _typeKH = TypeDebitDKKH.find((x: any) => x.value === row.type);
        const total_purchase = row.purchase_price + row.purchase_com;
        const thanh_tien_dv = Math.round(total_purchase * (1 + row.purchase_vat / 100));
        const thanh_tien_ch = Math.round(row.purchase_price * (1 + row.purchase_vat / 100));
        const thanh_tien = thanh_tien_dv;

        return {
            ...row,
            fileNumber: row?.file_number || "không file",
            declaration: row?.declaration || "",
            dispatch_code: row.type === 1 ? row.dispatch_code : "",
            bill: row?.sup_bill || "",
            file_bill: row?.bill || "",
            cont: row?.container_code || "",
            supplierName: sup?.partners?.name || "",
            supplierAbb: sup?.partners?.abbreviation || "",
            userName: `${_user?.last_name ?? ""} ${_user?.first_name ?? ""}`.trim(),
            typeKH: _typeKH?.name || "",
            thanhtien_dv: (row.type === 0 || row.type === 1 || row.type === 4 || row.type === 5 ||row.type === 10 ||row.type === 7) ? thanh_tien_dv : 0,
            thanhtien_ch: (row.type === 2 || row.type === 3 || row.type === 6 ||row.type === 11) ? thanh_tien_ch : 0,
            dathu_dv: (row.type === 0 || row.type === 1 || row.type === 4 || row.type === 5 ||row.type === 10 ||row.type === 7) ? row.receipt_total : 0,
            dathu_ch: (row.type === 2 || row.type === 3 || row.type === 6 ||row.type === 11) ? row.receipt_total : 0,
            conlai_dv_view: (row.type === 0 || row.type === 1 || row.type === 4 || row.type === 5 ||row.type === 10 ||row.type === 7) ? thanh_tien_dv - row.receipt_total : 0,
            conlai_ch_view: (row.type === 2 || row.type === 3 || row.type === 6 ||row.type === 11) ? thanh_tien_ch - row.receipt_total : 0,
            conlai_dv: (row.type === 0 || row.type === 1 || row.type === 4 || row.type === 5 ||row.type === 10  ||row.type === 7) ? thanh_tien_dv - row.receipt_total : 0,
            conlai_ch: (row.type === 2 || row.type === 3 || row.type === 6 ||row.type === 11) ? thanh_tien_ch - row.receipt_total : 0,
            conlai_tong: thanh_tien - row.receipt_total
        };
    });

    const filtered = applyFilters(mapped);
    setDisplayData(filtered);
}, [first, rows, data, paramsPaginator, filters, suppliers, employees]);
  const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column rowSpan={2} />
                <Column header="Ngày hạch toán" rowSpan={2} />
                <Column header="Nhà cung cấp" headerClassName="my-title-center" rowSpan={2} />
                <Column header="Chứng từ" headerClassName="my-title-center" colSpan={7} />
                <Column header="Nợ" headerClassName="my-title-center" colSpan={2} />
                <Column header="Đã thu" headerClassName="my-title-center" colSpan={2} />
                <Column frozen alignFrozen="right" className="font-bold"  header="Còn lại" headerClassName="my-title-center" colSpan={3} />
                <Column frozen alignFrozen="right" className="font-bold"  header="Số thu" headerClassName="my-title-center" colSpan={3} />
                <Column frozen alignFrozen="right" className="font-bold" header="Phiếu chi" headerClassName="my-title-center" rowSpan={3} />
            </Row>
            <Row>
                <Column header="Số file"/>
                <Column header="Số bill"/>
                <Column header="Số cont"/>
                <Column header="Số tờ khai"/>
                <Column header="Mã điều xe"/>
                <Column style={{width: "250px"}} header="Nội dung"/>
                <Column header="Số hóa đơn"/>
                <Column style={{width: "150px"}} header="Dịch vụ"/>
                <Column style={{width: "150px"}} header="Chi hộ"/>
                <Column header="Dịch vụ"/>
                <Column header="Chi hộ"/>
                <Column style={{width: "150px"}} frozen alignFrozen="right" className="font-bold" header="Dịch vụ" />
                <Column style={{width: "150px"}} frozen alignFrozen="right" className="font-bold" header="Chi hộ" />
                <Column style={{width: "150px"}} frozen alignFrozen="right" className="font-bold" header="Còn lại" />
                <Column frozen alignFrozen="right" className="font-bold" header="" />
                <Column style={{width: "140px"}} frozen alignFrozen="right" className="font-bold" header="Số thu dịch vụ" />
                <Column style={{width: "140px"}} frozen alignFrozen="right" className="font-bold" header="Số thu chi hộ" />
            </Row>
             <Row>
                <Column />
                <Column />
                <Column header={supplierAbbHeader}/>
                <Column header={fileNumberHeader}/>
                <Column header={fileBillHeader}/>
                <Column header={contHeader}/>
                <Column header={declarationHeader}/>
                <Column header={dispatchCodeHeader}/>
                <Column header={nameHeader}/>
                <Column header={billHeader}/>
                <Column />
                <Column />
                <Column />
                <Column /> 
                <Column header={phatSinhDichVuHeader} frozen alignFrozen="right" className="font-bold"/>
                <Column header={phatSinhChiHoHeader} frozen alignFrozen="right" className="font-bold"/>
                <Column frozen alignFrozen="right" className="font-bold"/>
                <Column frozen alignFrozen="right" className="font-bold"/>
                <Column frozen alignFrozen="right" className="font-bold"/>
                <Column frozen alignFrozen="right" className="font-bold"/>
            </Row>
        </ColumnGroup>
    );
  return (
    <>
      <div className="card">
        <Header
          _paramsPaginator={paramsPaginator}
          _setParamsPaginator={setParamsPaginator}
          selected={selectedRows} 
          refresh={refresh}
          _setSelectedRows={setSelectedRows}
        />
        <div style={{ height: 'calc(100vh - 8rem)' }}>
            <Splitter style={{ height: '100%', width: '100%' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <DataTableClient
                        rowHover
                        value={displayData}
                        currentPageReportTemplate="Tổng số: {totalRecords} bản ghi"
                        headerColumnGroup={headerGroup}
                        loading={loading}
                        dataKey="id"
                        title="Tài khoản"
                        filterDisplay="row"
                        className={classNames("Custom-DataTableClient")}
                        scrollable
                        scrollHeight="flex"
                        style={{ flex: 1 }}
                        tableStyle={{ minWidth: "2300px" }} // ép bảng rộng hơn để có scroll ngang
                      >
                        <Column field="accounting_date" body={(e: any) => DateBody(e.accounting_date)} filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="supplierAbb" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="fileNumber" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="file_bill" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="cont" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="declaration" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="dispatch_code" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="name" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="bill" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column // dịch vụ
                          body={(row: any) =>{
                            return Helper.formatCurrency(row.thanhtien_dv.toString());
                          }} 
                          footer={getSumColumn("thanhtien_dv")}
                          footerStyle={{ fontWeight: "bold" }}
                          style={{ textAlign: 'right' }}
                        />
                        <Column // chi hộ
                          body={(row: any) =>{
                            return Helper.formatCurrency(row.thanhtien_ch.toString());
                          }} 
                          footer={getSumColumn("thanhtien_ch")}
                          footerStyle={{ fontWeight: "bold" }}
                          style={{ textAlign: 'right' }}
                        />
                        <Column 
                          body={(row: any) =>{
                            return Helper.formatCurrency(row.dathu_dv.toString());
                          }}
                          style={{ textAlign: 'right' }}
                        />
                        <Column 
                          body={(row: any) =>{
                            return Helper.formatCurrency(row.dathu_ch.toString());
                          }} 
                          style={{ textAlign: 'right' }}
                        />
                        <Column  // còn dịch vụ
                          body={(row: any) =>{
                                return Helper.formatCurrency(row.conlai_dv_view.toString());
                          }} 
                          footer={getSumColumn("conlai_dv_view")}
                          footerStyle={{ fontWeight: "bold" }}
                          style={{ textAlign: 'right' }}
                          frozen 
                          alignFrozen="right" 
                          className="font-bold" 
                          />
                        <Column  // còn chi hộ
                          body={(row: any) =>{
                              return Helper.formatCurrency(row.conlai_ch_view.toString());
                          }} 
                          footer={getSumColumn("conlai_ch_view")}
                          footerStyle={{ fontWeight: "bold" }}
                          style={{ textAlign: 'right' }}
                          frozen 
                          alignFrozen="right" 
                          className="font-bold" 
                        />
                        <Column // còn lại tổng
                          body={(row: any) =>{
                              return Helper.formatCurrency(row.conlai_tong.toString());
                          }} 
                          footer={getSumColumn("conlai_tong")}
                          footerStyle={{ fontWeight: "bold" }}
                          style={{ textAlign: 'right' }}
                          frozen 
                          alignFrozen="right" 
                          className="font-bold"
                        />
                        <Column
                          header={
                            <Checkbox
                              checked={
                                selectedRows.length === displayData.length &&
                                displayData.length > 0
                              }
                              onChange={(e: any) => {
                                if (e.checked) setSelectedRows([...displayData]); // lưu nguyên object
                                else setSelectedRows([]);
                              }}
                            />
                          }
                          body={(rowData: any) => {
                            const total_purchase = rowData.purchase_price + rowData.purchase_com;
                            const thanh_tien = Math.round(total_purchase * (1 + rowData.purchase_vat / 100));
                            let conlai = thanh_tien - rowData.receipt_total;
                            conlai = Math.max(conlai, 0);
                            if(conlai > 0){
                              const isChecked = selectedRows.some(r => r.id === rowData.id); // check theo id
                              return (
                                <Checkbox
                                  className="p-checkbox-sm"
                                  checked={isChecked}
                                  onChange={(e: any) => {
                                    setSelectedRows(prev => {
                                      if (e.checked) {
                                        // add row: lấy object mới nhất từ displayData
                                        const rowFromDisplay = displayData.find(d => d.id === rowData.id);
                                        if (!prev.some(r => r.id === rowData.id) && rowFromDisplay) {
                                          return [...prev, rowFromDisplay];
                                        }
                                        return prev;
                                      } else {
                                        // remove row
                                        return prev.filter(r => r.id !== rowData.id);
                                      }
                                    });
                                  }}
                                  onClick={(e: any) => e.stopPropagation()}
                                />
                              );
                            }
                          }}
                          style={{ width: "3em" }}
                          frozen
                          alignFrozen="right"
                        />
                        <Column 
                        body={(row:any, options:any) => {
                          if(row.type === 0 || row.type === 1 || row.type === 4 || row.type === 5 ||row.type === 10 ||row.type === 7){
                            const purchase_price = typeof row.purchase_price === "string"
                              ? parseFloat(row.purchase_price.replace(/[^0-9.]/g, "")) || 0
                              : Number(row.purchase_price) || 0;
                            const purchase_com = typeof row.purchase_com === "string"
                              ? parseFloat(row.purchase_com.replace(/[^0-9.]/g, "")) || 0
                              : Number(row.purchase_com) || 0;
                            const purchase_vat = Number(row.purchase_vat) || 0;
                            const total_purchase = purchase_price + purchase_com;
                            const thanh_tien = Math.round(total_purchase * (1 + purchase_vat / 100));
                            const conlai = thanh_tien - (row.receipt_total || 0);
                            return (
                              <Input
                                  className="w-full input-sm"
                                  value={Helper.formatCurrency(String(row.conlai_dv > 0 ? row.conlai_dv : conlai))}
                                  onChange={(e: any) => {
                                    const newValue = parseInt(e.target.value.replace(/\D/g, ""), 10);

                                    setDisplayData(prev => {
                                      // Tạo mảng displayData mới
                                      const updated = [...prev];
                                      updated[options.rowIndex] = {
                                        ...updated[options.rowIndex],
                                        conlai_dv: newValue
                                      };

                                      // Đồng bộ selectedRows: nếu row đang chọn, cập nhật object mới
                                      setSelectedRows(prevSelected =>
                                        prevSelected.map(sel =>
                                          sel.id === row.id ? { ...updated[options.rowIndex] } : sel
                                        )
                                      );

                                      return updated;
                                    });
                                  }}
                                />
                            );
                          }
                        }} frozen alignFrozen="right" className="font-bold"/>
                        <Column 
                        
                        body={(row:any, options:any) => {
                          if(row.type === 2 || row.type === 3 || row.type === 6 ||row.type === 11){
                            const purchase_price = typeof row.purchase_price === "string"
                              ? parseFloat(row.purchase_price.replace(/[^0-9.]/g, "")) || 0
                              : Number(row.purchase_price) || 0;
                            const purchase_com = 0;
                            const purchase_vat = Number(row.purchase_vat) || 0;
                            const total_purchase = purchase_price + purchase_com;
                            const thanh_tien = Math.round(total_purchase * (1 + purchase_vat / 100));
                            const conlai = thanh_tien - (row.receipt_total || 0);
                            return (
                              <Input
                                  className="w-full input-sm"
                                  value={Helper.formatCurrency(String(row.conlai_ch > 0 ? row.conlai_ch : conlai))}
                                  onChange={(e: any) => {
                                    const newValue = parseInt(e.target.value.replace(/\D/g, ""), 10);

                                    setDisplayData(prev => {
                                      // Tạo mảng displayData mới
                                      const updated = [...prev];
                                      updated[options.rowIndex] = {
                                        ...updated[options.rowIndex],
                                        conlai_ch: newValue
                                      };

                                      // Đồng bộ selectedRows: nếu row đang chọn, cập nhật object mới
                                      setSelectedRows(prevSelected =>
                                        prevSelected.map(sel =>
                                          sel.id === row.id ? { ...updated[options.rowIndex] } : sel
                                        )
                                      );

                                      return updated;
                                    });
                                  }}
                                />
                            );
                          }
                        }} frozen alignFrozen="right" className="font-bold"/>
                          <Column field="receipt_codes" frozen alignFrozen="right" filter showFilterMenu={false} filterMatchMode="contains" />
                </DataTableClient>
                </div>
            </Splitter>
        </div>
      </div>
    </>
  );
}
